import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { loginReceived } from './state/actions/loginAction';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: true, disableClose: true },
    },
  ],
})
export class AppComponent implements OnInit {
  title = 'CustomerPortal';
  loggedIn = false;
  constructor(private store: Store) {}
  ngOnInit() {
    if (typeof window !== 'undefined') {
      if (localStorage.getItem('userData')) {
        this.store.dispatch(
          loginReceived({
            data: JSON.parse(localStorage.getItem('userData') || ''),
          }),
        );
      }
    }
  }
}
